import { $translate } from '@/utils/i18n';
export default {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: true,
        height: 400,
        columns: [
            {
                label: $translate('lang.E3202103220001', { defaultText: '企业前缀' }),
                align: 'center',
                prop: 'prefixCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202101260002', { defaultText: '租户' }),
                align: 'center',
                prop: 'tenantCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220010', { defaultText: '时间' }),
                align: 'center',
                prop: 'excuteTime',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220009', { defaultText: '消息体body' }),
                align: 'center',
                prop: 'requestBody',
                type: 'hint',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220002', { defaultText: '异常类型' }),
                align: 'center',
                prop: 'exceptionSource',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220008', { defaultText: '异常原因' }),
                align: 'center',
                prop: 'exceptionReason',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220007', { defaultText: '重推次数' }),
                align: 'center',
                prop: 'redoCounts',
                filter: true,
                require: true,
                width: 100
            }
        ],
        action: [
            {
                type: 'text',
                label: $translate('lang.E3202103220011', { defaultText: '处理' }),
                size: 'small',
                event: 'edit'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
